"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  mainHeading: _propTypes["default"].string,
  headingTag: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  textAlignment: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  link: _propTypes["default"].object,
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = exports["default"] = PROP_TYPES;